import {
  FormField,
} from '@codev/helix-react';
import {
  FormControl,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import translations from './translations.js';

const View = ({
  language = 'en_US',
  loading,
  onChange,
  verificationCode,
  style,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      textAlign: 'center',
      ...style
    }}
  >
    {
      loading &&
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          height: '401px',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Spinner
          className="warning"
          style={{
            height: '3em',
            width: '3em',
          }}
        />
      </div>
    }
    {
      !loading &&
      <>
        <div>
          {translations('stepText', language)}
        </div>
        <div style={{ fontWeight: 500, paddingTop: '20px' }}>
          {translations('codeDescription', language)}
        </div>
        <div style={{ display: 'flex', paddingLeft: '42%', paddingTop: '10px'}}>
          <FormField
            isRequired
            isRequiredErrorMessage={translations('isRequiredMessage', language)}
            style={{
              height: '50px',
            }}
            validate={[
              () => {
                if (!(new RegExp(/^\d{6}$/).test(verificationCode))) {
                  return <span style={{marginLeft: '-65px', position: 'fixed'}}>{translations('verificationError', language)}</span>;
                }
              }
            ]}
            value={verificationCode}
          >
            <FormControl
              autoFocus
              onChange={(event) => onChange(event.target.value)}
              style={{
                width: '130px',
              }}
              type="text"
              value={verificationCode}
            />
          </FormField>
        </div>
      </>
    }
  </div>
);

View.propTypes = {
  language: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  verificationCode: PropTypes.string,
};

export default View;